import React, { useState } from 'react';
import '../../styles/admin/ProductTable.css';

const ProductTable = ({ products, onEdit, onDelete, onAdd }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');

  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.barcode.includes(searchTerm);
    const matchesType = filterType === 'all' || product.type === filterType;
    return matchesSearch && matchesType;
  });

  const getStockStatus = (qty) => {
    if (qty === 0) return { text: 'Out of Stock', class: 'out-of-stock' };
    if (qty < 10) return { text: 'Low Stock', class: 'low-stock' };
    return { text: 'In Stock', class: 'in-stock' };
  };

  return (
    <div className="product-table-container">
      <div className="table-header-section">
        <h2><i className="fas fa-box"></i> Product Management</h2>
        <button className="add-product-btn" onClick={onAdd}>
          <i className="fas fa-plus"></i>
          <span>Add Product</span>
        </button>
      </div>

      <div className="table-controls">
        <div className="search-box">
          <i className="fas fa-search"></i>
          <input
            type="text"
            placeholder="Search by name or barcode..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="filter-group">
          <label>Filter:</label>
          <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
            <option value="all">All Types</option>
            <option value="fixed">Fixed Price</option>
            <option value="weight">Weight Based</option>
          </select>
        </div>
      </div>

      <div className="table-scroll-wrapper">
        <table className="product-table">
          <thead>
            <tr>
              <th>Barcode</th>
              <th>Product Name</th>
              <th>Type</th>
              <th>Price</th>
              <th>Price/Kg</th>
              <th>Stock</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.length === 0 ? (
              <tr>
                <td colSpan="8" className="no-data">
                  <i className="fas fa-inbox"></i>
                  <p>No products found</p>
                </td>
              </tr>
            ) : (
              filteredProducts.map((product) => {
                const status = getStockStatus(product.stockQty);
                return (
                  <tr key={product._id}>
                    <td className="barcode-cell">{product.barcode}</td>
                    <td className="name-cell">{product.name}</td>
                    <td>
                      <span className={`type-badge ${product.type}`}>
                        {product.type === 'fixed' ? 'Fixed' : 'Weight'}
                      </span>
                    </td>
                    <td className="price-cell">
                      {product.type === 'fixed' ? `LKR ${product.price.toFixed(2)}` : '-'}
                    </td>
                    <td className="price-cell">
                      {product.type === 'weight' ? `LKR ${product.pricePerKg.toFixed(2)}` : '-'}
                    </td>
                    <td className="qty-cell">{product.stockQty}</td>
                    <td>
                      <span className={`status-badge ${status.class}`}>
                        {status.text}
                      </span>
                    </td>
                    <td className="actions-cell">
                      <button 
                        className="action-btn edit-btn" 
                        onClick={() => onEdit(product)}
                        title="Edit Product"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button 
                        className="action-btn delete-btn" 
                        onClick={() => onDelete(product._id)}
                        title="Delete Product"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div className="table-footer">
        <p>Showing {filteredProducts.length} of {products.length} products</p>
      </div>
    </div>
  );
};

export default ProductTable;